// define(
//     [
//     "shared/user",
//     "shared/client",
// 	"shared/helpers"
//     ], function(User, Client, Helpers) {

//     /**
//      * Helper function to initialize the pendo app with user metadata
//      * @author Dale Kelly
//      * @dateCreated 01/19/2021
//      */
//     var Pendo = function Pendo(){};

//     /**
//      * Driver function to start the pendo initialization process
//      * @author Dale Kelly
//      * @dateCreated 01/19/2021
//      * @param {Object} pendo    the pendo object stored in the window
//      */
//     Pendo.prototype.init = function(pendo) {
//         // student checks to ensure COPPA compliance
//         let visitorData = {};
//         if (User.isStudentStrict() || Helpers.is_student_regex_check(User.getEmail()) ||
//             Helpers.is_student_regex_check(User.getProperty('username')) ||
//             Helpers.is_student_regex_check(User.getProperty('first_name')) ||
//             Helpers.is_student_regex_check(User.getProperty('last_name'))) {
//             // Setting to null erases the data in Pendo, retroactively wipes all personally identifiable data
//             // from users who incorrectly failed student check (students with accounts with type & title != student)
//             visitorData = {
//                 id: User.getGUID(),
//                 firstName: null,
//                 lastName: null,
//                 email: null,
//                 unsubscribed: null,
//                 trialStartDate: null,
//                 trialEndDate: null,
//                 country: null,
//                 subscriptionStartDate: null,
//                 subscriptionEndDate: null,
//                 subscriptionPlan: null,
//                 coupon: null,
//                 subscriptionStatus: null,
//                 isVerifiedStudent: true, // flag to identify these student account types in Pendo Segments
//             }
//         }
//         else {
//             visitorData = {
//                 id: User.getGUID(),
//                 firstName: User.getProperty('first_name'),
//                 lastName: User.getProperty('last_name'),
//                 email: User.getEmail(),
//                 unsubscribed: User.isUnsubscribed(),
//                 trialStartDate: User.getProperty('trial_started_at'),
//                 trialEndDate: User.getProperty('trial_ends_at'),
//                 country: User.getCountry(),
//                 subscriptionStartDate: User.getProperty('active_subscription_started_at'),
//                 subscriptionEndDate: User.getProperty('active_subscription_ends_at'),
//                 subscriptionPlan: User.getProperty('active_subscription_plan'),
//                 subscriptionPlanName: User.getSubscriptionPlanName(User.getProperty('active_subscription_plan')),
//                 coupon: User.getProperty('active_coupon_id'),
//                 subscriptionStatus: User.getSubscriptionStatus(),
//                 previousUserType: User.getPrevUserType(),
//                 state: User.getState(),
//                 fromGDPRCountry: User.isFromGDPRCountry(),
//             }
//         }

//         pendo.initialize({
//             visitor: Object.assign(visitorData, {
//                 creationDate: User.getProperty('created_at'),
//                 type: User.getUserType(),
//                 title: User.getUserTitle(),
//             }),

//             account: {
//                 id: Client.getName(), // tenent name the specific user account belongs to
//             }
//         });
//     }

// 	/**
// 	 * Registers an event performed by a user to be sent to Pendo: Track Events
// 	 * @author Haley He
// 	 * @date 3/30/2021
// 	 * @param {String}  eventName	The name of the action the user has performed
// 	 * @param {Object}  data 		Any additional metadata and properties associated with the event
//      * @param {Integer} attempt     Number of times we tried to send this track event
// 	 */
//      Pendo.prototype.pendoTrack = function(eventName, data, attempt) {
//         var self = this;
// 		var pendo = window.pendo;
// 		var user = window.appData.user.data;

// 		// Ensure that pendo agent is loaded first and ready before calling pendo.track()
// 		if (pendo && pendo.isReady && pendo.isReady()) {
// 			// Default user data sent to all events
// 			if (user !== null) {
//                 data.userID = User.getGUID();
//                 data.userType = User.getUserType();
//                 data.accountID = Client.getName();
// 			}

//             return pendo.track(eventName, data);
// 		}

// 		// Pendo is not ready yet, attempt to call pendo track again. 
//         // Ensure pendo object exists at all before attempting call pendoTrack
// 		if (pendo) {
// 			setTimeout(() => {
//                 if (attempt < 5) {
//                     self.pendoTrack(eventName, data, attempt+1);
//                 }
// 			}, 500);
// 		}
// 	}
    
//     return new Pendo();
// });
define("shared/pendo", function(){});

